export const primaryGrades = ["PK", "TK", "K", "1", "2", "3", "4", "5"];
export const secondaryGrades = ["6", "7", "8", "9", "10", "11", "12", "OTHER"];
export type GradeScope = "primary" | "secondary" | "all";
